import { TileLayer } from 'react-leaflet';

/**
 * Tiles de OpenStreetMap para los mapas de Locaciones. La atribución es obligatoria por
 * licencia; se centraliza acá para no repetir URL ni crédito entre el picker y el mapa
 * de solo lectura del detalle.
 */
export function OsmTileLayer() {
  return (
    <TileLayer
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
  );
}
